<template>
    <div class="loadingBox">
        <div class="loadingMain">
            <div class="loadingCenter">
                <div class="loadingIcon">
                    <span></span>
                </div>
                <p>登陆中,请稍后</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'login'
}
</script>

<style lang="less" scoped>
.loadingBox {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 999;
}

.loadingBox .loadingIcon {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loadingBox .loadingIcon span {
    height: 64px;
    width: 64px;
    background: url(../assets/icon/loading-hyd.gif) center center no-repeat;
    background-size: 100% 100%;
    /* animation: rotateBox 2s linear infinite; */
}

.loadingBox .loadingMain {
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    height: 100%;
    cursor: not-allowed;
}

.loadingBox p {
    color: var(--white);
    font-size: 16px;
    text-align: center;
}
</style>